export const STATUSES = {
  CREATED: "CREATED",
  WAITING_CLINIC: "WAITING_CLINIC",
  WAITING_USER: "WAITING_USER",
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE",
  RESOLVED: "RESOLVED",
  FINISHED: "FINISHED",
};

export const STATUS_COLOR_GROUPS = {
  WAITING: [STATUSES.WAITING_CLINIC, STATUSES.WAITING_USER],
  REJECTED: [STATUSES.INACTIVE],
  ACTIVE: [STATUSES.ACTIVE],
  RESOLVED: [STATUSES.RESOLVED],
  FINISHED: [STATUSES.FINISHED],
};

// Color values can be hex codes, CSS color names, or tailwind-style utility classes
export const STATUS_COLORS = {
  WAITING: "#ffb703", // yellow
  REJECTED: "rgb(255, 64, 64)", // red
  ACTIVE: "rgb(97, 189, 36)", // green
  FINISHED: "rgb(34, 126, 255)", // blue
  RESOLVED: "#7cafc4",
};

export function getStatusColor(status) {
  for (const [group, statuses] of Object.entries(STATUS_COLOR_GROUPS)) {
    if (statuses.includes(status)) {
      return STATUS_COLORS[group];
    }
  }
  return null;
}
